module.exports = __webpack_public_path__ + "static/img/04guangpan.dd8dcb0a.gif";